









import { Component, Watch, Vue } from "vue-property-decorator";
import { mapState } from "vuex";
import Header from "@/components/Header.vue";
import ListView from "@/components/schedule/CheckinList.vue";


@Component({
  components: {
    Header,
    ListView,
  },
  computed: {
    ...mapState("schedule", ["view", "list"]),
  },
})
export default class Checkin extends Vue {


  mounted() {

  }
}
